/*
  Colour strikethrough (product page)

  Marks colour swatches that are sold out in the size the customer has selected.
  - Data: each .ProductItem__ColorSwatchLink carries data-sizes-in-stock="|S|M|L|"
    (rendered in snippets/product-meta.liquid).
  - Trigger: the theme's "variant:changed" event (fired when a size is picked).
  - On/off: Theme settings > Product page > "Strike through colours sold out in the selected size".
  Marked colours stay clickable, so customers can still open them and sign up for back in stock.
*/
(function () {
  if (window.__colourStrikethroughLoaded) return;
  window.__colourStrikethroughLoaded = true;

  var MARK_CLASS = 'is-sold-out-in-size';
  var LINK_SELECTOR = '.ProductItem__ColorSwatchLink[data-sizes-in-stock]';

  function ensureLine(link) {
    var wrapper = link.querySelector('.SwatchWrapper');
    if (!wrapper || wrapper.querySelector('.ColourStrikethrough__Line')) return;
    var line = document.createElement('span');
    line.className = 'ColourStrikethrough__Line';
    line.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(line);
  }

  function update(scope, size) {
    var links = scope.querySelectorAll(LINK_SELECTOR);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var inStock = link.getAttribute('data-sizes-in-stock') || '';
      var soldOut = !!size && inStock.indexOf('|' + size + '|') === -1;

      link.classList.toggle(MARK_CLASS, soldOut);

      if (soldOut) {
        ensureLine(link);
        var list = link.closest('.ProductItem__ColorSwatchList');
        var label = list ? list.getAttribute('data-sold-out-label') : '';
        var img = link.querySelector('img');
        var colour = img ? img.getAttribute('alt') : '';
        if (colour && label) link.setAttribute('aria-label', colour + ' – ' + label);
      } else {
        link.removeAttribute('aria-label');
      }
    }
  }

  function scopeFor(element) {
    return (element && element.closest && element.closest('.shopify-section')) || document;
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var size = variant && variant.option1 ? String(variant.option1) : null;
    update(scopeFor(event.target), size);
  });

  function init() {
    // A size can already be selected on load (e.g. ?variant= in the URL)
    var checked = document.querySelectorAll('.ProductForm .SizeSwatch__Radio:checked');
    for (var i = 0; i < checked.length; i++) {
      update(scopeFor(checked[i]), checked[i].value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();